/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodUnamused = createReactComponent("mood-unamused", "IconMoodUnamused", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M11 16l4 -1.5", key: "svg-1" }],
  ["path", { d: "M10 10c-.5 -1 -2.5 -1 -3 0", key: "svg-2" }],
  ["path", { d: "M17 10c-.5 -1 -2.5 -1 -3 0", key: "svg-3" }]
]);

export { IconMoodUnamused as default };
//# sourceMappingURL=IconMoodUnamused.js.map
